import Result, { ErrorResult } from '@/model/api';
import axios, { AxiosError, AxiosRequestConfig, HttpStatusCode } from 'axios';
import instance from './_interceptor';

const axiosController: Controller = {};

interface Controller {
	[uuid: string]: AbortController[];
}

export interface AxiosRequestCustomConfig extends AxiosRequestConfig {
	signalUUID?: string;
	_isRefreshing?: boolean;
	_isRetry?: boolean;
}

export default async function useFetch<T>(config: AxiosRequestCustomConfig): Promise<Result<T>> {
	const controller = new AbortController();
	if (!config.signal) {
		config.signal = controller.signal;
	}

	try {
		if (config?.signalUUID) {
			if (axiosController[config.signalUUID]) {
				axiosController[config.signalUUID].forEach((ctrl) => ctrl.abort());
				axiosController[config.signalUUID].length = 0;
			} else {
				axiosController[config.signalUUID] = [];
			}
			axiosController[config.signalUUID].push(controller);
		}

		const response: Result<T> = {};
		await instance
			.request<T>({ ...config })
			.then((res) => {
				response.data = res.data;
				response.status = res.status;
				response.headers = res.headers;
			})
			.catch((err: AxiosError) => {
				if (err.response?.status === HttpStatusCode.InternalServerError) {
					console.error(err);
					// goto("/internal-server-error");
				}
				response.status = err.response?.status;
				response.error = err.response?.data as ErrorResult;
				response.headers = err.response?.headers;
			});
		return response;
	} catch (error) {
		if (!axios.isCancel(error)) {
			const err = error as AxiosError<T>;
			return Promise.reject(err.response?.data || err.response || error);
		}
		return Promise.reject(error);
	}
}
